module.exports = __webpack_public_path__ + "img/settings-w.svg";